import type { OnboardingItemKey } from './__generated__/navRefreshOptOutQuery.graphql';

export const NAV_REFRESH_OPT_OUT_KEY: OnboardingItemKey = 'NAV_REFRESH_OPT_OUT';
export const NAV_REFRESH_ADMIN_OPT_IN: OnboardingItemKey = 'NAV_REFRESH_ADMIN_OPT_IN';
